import i18n from 'i18next';

class PathStore {
  pathWithLang = (path = '') => {
    return `/${i18n.language}${path}`;
  };
}

export default new PathStore();
